import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "./Slider";
import HomeSliderSection from "./HomeSliderSection";

const SliderWrapper = ({image}) => {
    const [sliders, setSliders] = useState([]);
    const [loading, setLoading] = useState(true);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

    useEffect(() => {
        const cachedData = JSON.parse(localStorage.getItem("sliderData"));

        if (cachedData) {
            const { data, timestamp } = cachedData;
            const currentTime = Date.now();

            if (currentTime - timestamp < cacheExpiryTime) {
                setSliders(data);
                setLoading(false);
                return;
            } else {
                localStorage.removeItem("sliderData");
            }
        }

        fetchSliderData();
    }, []);

    const fetchSliderData = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const url = process.env.REACT_APP_API_SLIDERS;

        try {
            const response = await axios.get(`${apiBaseUrl}${url}`);
            const data = response.data;
            const dataWithTimestamp = {
                data,
                timestamp: Date.now()
            };
            localStorage.setItem("sliderData", JSON.stringify(dataWithTimestamp));
            setSliders(data);
        } catch (error) {
            console.error("Failed to fetch slider data:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return null;

    return (
        <>
            <div className="">
                <div className="container px-1 pt-2 pb-2">
                    <div className="row g-0">
                        <div className="col-xxl-12">
                            <div className="banner__img-wrapper">
                                <img
                                    src={`${process.env.PUBLIC_URL}/${image}`}
                                    alt="Banner"
                                    className="img-fluid w-100"
                                    style={{ borderRadius:"15px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*{sliders.length > 1 ? (
                <Slider sliders={sliders} />
            ) : (
                <HomeSliderSection sliders={sliders} />
            )}*/}
        </>
    );
};

export default SliderWrapper;
